
import instance from './axios'

console.log(instance)
// get请求
export function getAction(url,params) {
  return instance({
    url: url,
    method: 'get',
    params
  })
}
// post请求
export function postAction(url,data) {
  return instance({
    url: url,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
// 退出成功Post请求
export function LogoutPostAction(url,headers) {
  return instance({
    url: url,
    method: 'post',
    headers:{
      'Content-Type': 'application/json',
      'X-Access-Token':headers,
      "Access-Control-Allow-Origin":"*"
    }
  })
}
// 个人信息get请求
export function PersonalGetAction(url,headers,params) {
  return instance({
    url: url,
    method: 'get',
    headers:{
      'Content-Type': 'application/json',
      'X-Access-Token':headers
    }
  })
}

/* export function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)
    })
});} */
// 注册post请求
export function SignPostAction(url,data,channel) {
  return instance({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json' ,
      'channel':channel
     },
    data
  })
}
// 课程 请求
export function HeadGetAction(url,token,openId,mobile,data) {
  return instance({
    url: url,
    method: 'GET',
    headers: {
      'Content-Type':'application/json;charset=UTF-8',
      'X-Access-Token':token,
      'x-platform':4,
      'unionID':openId,
      'Tourists-Identity':mobile,
    },
    data:data,
  })
}
export function HeadPostAction(url,token,data) {
  return instance({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'X-Access-Token':token,
      'x-platform':4,
    },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/url.js